export default __webpack_public_path__ + "static/media/MPCAS_Univas.2ed47081.png";